import { Injectable } from '@angular/core';
import {
    CanActivate,
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { AuthService } from '../auth.service';
import { isAdminRole, extractUserRole } from '../role.constants';

/**
 * AdminGuard — Hanya izinkan role admin (Owner, Keeper, Administrator).
 * Jika user role Renter → redirect ke /user/home.
 * Jika belum login → redirect ke /sign-in.
 */
@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private router: Router
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | boolean | UrlTree {
        return this.authService.check().pipe(
            switchMap((authenticated) => {
                if (!authenticated) {
                    return of(this.router.createUrlTree(['/sign-in']));
                }

                const user = this.authService.getCurrentUser();
                const role = extractUserRole(user?.role || user);

                if (isAdminRole(role)) {
                    return of(true);
                }

                // Renter trying to access admin → redirect to user home
                console.warn(`[AdminGuard] Role "${role}" tidak diizinkan akses admin routes`);
                return of(this.router.createUrlTree(['/user/home']));
            })
        );
    }
}
